import React, { PureComponent } from 'react';
import { Panel, Button } from 'components';
import { HELPER, JsBridge } from 'utils';
import defaultIcon from 'assets/images/default-icon-placeholder-100.png';
// import { CACHE_CUSTOMER_NUMBER } from 'constant/ConstVariable';
import { CHECK_SELECTED, CHECK_UNSELECTED } from 'assets';
import axios from 'axios';
import { get } from 'lodash';
import close from './assets/close.svg';
import text from './ConfirmPanel.translation';
import config from './ConfirmPanel.component.config';
import './ConfirmPanel.less';

class ConfirmPanel extends PureComponent {
  _onChangePanel = isOpen => {
    this.props.onChangePanel(isOpen);
  };

  _onCloseConfirmPanel = () => {
    this.props.onCloseConfirmPanel(false);
  };

  _renderTitle = () => {
    const {
      biller,
      checkout,
      customerNumber,
      intl: { formatMessage },
    } = this.props;

    const iconSrc = get(biller, 'icon_abs_url', defaultIcon);
    const billerName = get(biller, 'name');
    const serviceName = get(biller, 'service.name');
    const billerServiceName = `${billerName} - ${serviceName}`;

    const beneficiaryFullName = get(checkout, 'beneficiary_full_name', '');

    return (
      <div className="panel-title">
        <div className="panel-title-head">
          <div onClick={this._onCloseConfirmPanel} className="close">
            <img src={close} alt="close" />
          </div>
          <span>{formatMessage(text.paymentDetail)}</span>
        </div>
        <div className="panel-title-main">
          <div className="biller-section">
            <div className="biller-icon">
              <img src={iconSrc} alt="biller-icon" />
            </div>
            <div className="biller-text">
              <p className="account-number">
                {HELPER.formatNumber(get(customerNumber, 'custNumber', ''))}
              </p>
              <p className="account-type-name">{billerServiceName}</p>
              <p className="account-name">
                {HELPER.replaceStarToCircle(beneficiaryFullName)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  _renderBody = () => {
    const {
      checkout,
      customerNumber,
      intl: { formatMessage },
    } = this.props;

    const transactionAmount = get(checkout, 'transaction_amount', '0');
    const transactionAmountRp = HELPER.formatRupiah(transactionAmount);
    const adminFee = get(checkout, 'admin_fee', '0');
    const adminFeeRp = HELPER.formatRupiah(adminFee);
    return (
      <div className="panel-body">
        <div className="body-items">
          <div className="body-list">
            <div>{formatMessage(text.amount)}</div>
            <div>{transactionAmountRp}</div>
          </div>
          <div className="body-list">
            <div>{formatMessage(text.adminFee)}</div>
            <div>{adminFeeRp}</div>
          </div>
          {get(this.props, 'biller.biller_type') === 2 && (
            <div className="body-list">
              <div>{formatMessage(text.vaTarget)}</div>
              <div className="va-target">
                <div>{get(customerNumber, 'prefix.bank_name')}</div>
                <div>
                  {get(this.props, 'checkout.beneficiary_account_number')}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  _renderButton = () => {
    const {
      onConfirm,
      intl: { formatMessage },
      billerWithTnc,
      checkedTnc,
    } = this.props;

    let btnClass = '';

    if (billerWithTnc) {
      btnClass = !checkedTnc ? 'inactive' : '';
    }
    return (
      <Button
        id="btn_confirm"
        addClass={`primary full no-margin ${btnClass}`}
        action={onConfirm}
      >
        <span>{formatMessage(text.confirm)}</span>
      </Button>
    );
  };

  _renderFooter = () => {
    const { checkout, intl, billerWithTnc } = this.props;

    const { formatMessage } = intl;
    const totalAmount = get(checkout, 'total_amount', '0');
    const totalAmountRp = HELPER.formatRupiah(totalAmount);

    return (
      <div className="panel-footer">
        {billerWithTnc && this._renderTnCArea()}
        <div className="total-info">
          <div className="text-info">{formatMessage(text.payYou)}</div>
          <div>
            <b>{totalAmountRp}</b>
          </div>
        </div>
        {this._renderButton()}
      </div>
    );
  };

  handlePopTnc = tnc => {
    const currentDate = new Date();
    const timestamp = currentDate.getTime();
    localStorage.removeItem('temporary_tnc');
    localStorage.setItem('temporary_tnc', tnc);
    const host = window.location.protocol
      .concat('//')
      .concat(window.location.host);
    const urlContent = `${host}/tnc.html?read=${timestamp}`;

    if (window.IS_IN_SKYWALKER) {
      JsBridge.call('callSubApp', {
        url: urlContent,
      });
    } else {
      const win = window.open(urlContent, '_blank');
      win.focus();
    }
  };

  _openTnC = () => {
    const { biller, setLoading } = this.props;

    const contentTnc = get(biller, 'tnc.latest_content_url', '');
    // sessionStorage.setItem(
    //   CACHE_CUSTOMER_NUMBER,
    //   get(formValue, 'customer_number', ''),
    // );
    // Disable Saving
    // sessionStorage.setItem(CACHE_AMOUNT, get(formValue, 'amount', ''));
    // sessionStorage.setItem(CACHE_FROM_TNC, true);
    setLoading(true);
    axios
      .get(contentTnc)
      .then(response => {
        setLoading(false);
        this.handlePopTnc(response.data[HELPER.getLang()]);
      })
      .catch(() => {
        setLoading(false);
        this.handlePopTnc('TNC NOT AVAILABLE');
      });
  };

  _renderTnCArea = () => {
    const {
      intl: { formatMessage },
      checkedTnc,
      onCheckTnc,
    } = this.props;

    return (
      <div className="tnc-area">
        <div className="tnc-checkbox" onClick={onCheckTnc}>
          <img
            src={checkedTnc ? CHECK_SELECTED : CHECK_UNSELECTED}
            alt="radio"
          />
        </div>
        {formatMessage(text.tnc.before)}

        <span className="tnc-btn" onClick={this._openTnC}>
          {formatMessage(text.tnc.btn)}
        </span>
      </div>
    );
  };

  render() {
    const { visible } = this.props;

    return (
      <Panel visible={visible} onChange={this._onChangePanel} pullable={false}>
        <div className="confirm-panel">
          {this._renderTitle()}
          {this._renderBody()}
          {this._renderFooter()}
        </div>
      </Panel>
    );
  }
}

ConfirmPanel.displayName = config.displayName;
ConfirmPanel.defaultProps = config.defaultProps;
ConfirmPanel.propTypes = config.propTypes;

export default ConfirmPanel;
